import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from "@material-ui/core";
import {
  StyledTableCell, useStyles
} from "components/request-document/components/Commons";


import InputLabel from "@material-ui/core/InputLabel";
import { getErrorMessage, isError, personalFieldResolver } from "libs/utils/form";
import { get } from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { canEditForm } from "redux/modules/authSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";

import withLayout from "components/HoC/withLayout";
import JobSection from "components/home/components/PreApproved/JobSection";
import PassportSection from "components/home/components/PreApproved/PassportSection";
import PersonalInfoSection from "components/home/components/PreApproved/PersonalInfoSection";
import TravelInfo from "components/home/components/PreApproved/TravelInfo";
import WorkPermit from "components/home/components/PreApproved/WorkPermit";
import {
  useAddress
} from "components/ltr-request-document/components/Address";
import CompanyInfoSection from "components/ltr-request-document/components/CompanyInfoSection";
import UploadDucument from "components/ltr-request-document/components/UploadDucument";
import VisaIssuanceSection from "components/ltr-request-document/components/VisaIssuanceSection";
import useSmartService from "components/request-document/hooks/useSmartService";
import { useFormik } from "formik";
import HttpClient from "libs/utils/HttpClient";
import { useParams } from "react-router-dom";
import { addPersonal } from "redux/modules/addPersonalSlice";
import {
  getDocumentRequiredPreApprove,
  getSmartForm, getSmartFormFieldConfig, selectSmartFormFieldConfig
} from "redux/modules/visaForm";
import * as yup from "yup";

import {
  defaultJobWorkpermitTable,
  getDefaultRow, mapJobWorkpermitTable
} from "libs/utils/form";


function PreApproved({ colSpan = 6 }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const masterData = useSelector(selectMasterData);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const canEdit = useSelector(canEditForm);
  const params = useParams();
  const [disabled, setDisabled] = useState({
    PersonalInformation: true,
    VisaIssuance: true,
    AddressInThailand: true,
    Passport: true,
    LatestTravelnformation: true,
    DigitalWorkPermit: true,
    CompanyInformation: true,
    JobInformation: true,
  })
  const [dataDetail, setDataDetail] = useState([]);
  const draftId = get(params, "draftId", "") || "";

  const { smartserviceId } = useSmartService();

  const history = useHistory();

  useEffect(async () => {
    dispatch(
      getMasterData({
        nationalityConfig: true,
        CountryConfig: true,
        visaTypeConfig: true,
        immPointConfig: true,
        vehicleConfig: true,
        countryEmbassy: true,
        CityConfig: true,
        VisaTypeConfig: true,
        theImmigrationBureauConfig: true,
        JobPositionConfig: true,
        accommodationConfig: true,
        titleConfig: true,
        companyTypeConfig: true,
        enterprisesConfig: true,
      })
    );
    // const res2 = await dispatch(getAllDocumentsList({ draftId: draftId }));
    const res3 = await dispatch(getSmartForm({ draftId: draftId }));
    dispatch(
      getDocumentRequiredPreApprove({
        draftId,
      })
    );

    dispatch(getSmartFormFieldConfig({ smartserviceId: res3?.payload?.smartserviceId, smartserviceGroupID: 'LTR' }));
    // console.log(res3.payload);
    // console.log(res2?.payload[0]);
    setDataDetail(res3?.payload);
  }, [dispatch]);

  useEffect(() => {
    // TODO uncomment for check disabled group
    // const checkDisabledGroup = async () => {
    //   const response = await HttpClient.post(
    //     `/api/visaform/smartfrom/checkxxxxxxxx`,
    //   );
    // }

    // setDisabled(response.results)
    // checkDisabledGroup()

    // TODO remove after integrate api check should disabled group
    setDisabled({
      PersonalInformation: false,
      VisaIssuance: false,
      AddressInThailand: false,
      Passport: false,
      LatestTravelnformation: false,
      DigitalWorkPermit: false,
      CompanyInformation: false,
      JobInformation: false,
    })

  }, [])

  const detailList = [
    "WPCompanyRegisterNumber",
    "WPCompanyName",
    "WPCompanyAddress",
    "WPCompanyOfficeNumber",
    "WPCompanyWebsite",
    "WPCompanyProductsServices",
    "WPContractTermType",
    "WPContactPersonInThai",
    "WPContactRelationship",
    "WPContactEmail",
    "WPContactMobile",
    "WPContractYear",
    "WPContractMonth",
    "WPContractOther",
    "WPContractPeriodFrom",
    "WPContractPeriodTo",
    "JobPositionWorkPermit",
    "DesiredWorkingPeriodID",
    "DesiredWorkingPeriodYear",
    "DesiredWorkingPeriodMonth",
    "PeriodStart",
    "PeriodEnd",
    "companyType",
    "emp_idcard_no",
    "emp_fullname",
    "emp_address",
    "emp_province_ddl",
    "emp_district_ddl",
    "emp_subdistrict_ddl",
    "emp_tel",
    // "PhoneNumber",
    // "Email",
  ];


  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
  const smartformDetail = get(dataDetail, "detail", []).reduce(
    smartNameById,
    {}
  );

  const detail = get(dataDetail, "detail", [])
    .filter((field) => detailList.includes(field.smartName))
    .reduce(smartNameById, {});

  const validationSchema = yup.object({
    // visaNo: yup.string().when("visaissuance.thailand", {
    //   is: (thailand) => thailand,
    //   then: yup.string().required("Visa Number. is required."),
    //   otherwise: yup.string(),
    // }),
    // visatypeId: yup.string().when("visaissuance.thailand", {
    //   is: (thailand) => thailand,
    //   then: yup.string().required("Type of visa you are holding is required."),
    //   otherwise: yup.string(),
    // }),
    // visaIssue: yup.string().when("visaissuance.thailand", {
    //   is: (thailand) => thailand,
    //   then: yup
    //     .string()
    //     .required("Place of visa issuance/ issued at is required."),
    //   otherwise: yup.string(),
    // }),
    // immPointID: yup.string().when("visaissuance.thailand", {
    //   is: (thailand) => thailand,
    //   then: yup.string().required("Port of entry is required."),
    //   otherwise: yup.string(),
    // }),
    // immNo: yup.string().when("visaissuance.thailand", {
    //   is: (thailand) => thailand,
    //   then: yup.string().required("TM 6. is required."),
    //   otherwise: yup.string(),
    // }),
    // fromCountryID: yup.string().when("visaissuance.thailand", {
    //   is: (thailand) => thailand,
    //   then: yup.string().required("Travel from (country)  is required."),
    //   otherwise: yup.string(),
    // }),
    // vehicleID: yup.string().when("visaissuance.thailand", {
    //   is: (thailand) => thailand,
    //   then: yup.string().required("Mean of transport  is required."),
    //   otherwise: yup.string(),
    // }),
    // thaiLastDate: yup.string().when("visaissuance.thailand", {
    //   is: (thailand) => thailand,
    //   then: yup
    //     .string()
    //     .required("The latest arrival date in Thailand is required."),
    //   otherwise: yup.string(),
    // }),
    // stampEXP: yup.string().when("visaissuance.thailand", {
    //   is: (thailand) => thailand,
    //   then: yup.string().required("Permitted to stay in Thailand is required."),
    //   otherwise: yup.string(),
    // }),
    workpermit: yup.object().when("visaissuance.thailand", {
      is: (thailand) => thailand,
      then: yup.object().shape({
        accommodationID: yup.string().required("Residence Type is required."),
        houseNumber: yup.string().required("HouseNumber Type is required."),
        soi: yup.string().required("Soi  is required."),
        road: yup.string().required("Road  is required."),
        addressInThailand: yup.string().required("Road  is required."),
        ProvinceId: yup.string().required("Province  is required."),
        DistrictId: yup.string().required("District  is required."),
        SubDistrictId: yup.string().required("Sub-District  is required."),
        Zipcode: yup.string().required("Zipcode  is required."),
        // --
        visaNo: yup.string().required("Visa Number. is required."),
        visatypeId: yup.string().required("Type of visa you are holding is required."),
        visaIssue: yup
          .string()
          .required("Place of visa issuance/ issued at is required."),
        immPointID: yup.string().required("Port of entry is required."),
        immNo: yup.string().required("TM 6. is required."),
        fromCountryID: yup.string().required("Travel from (country)  is required."),
        vehicleID: yup.string().when("visaissuance.thailand", {
          is: (thailand) => thailand,
          then: yup.string().required("Mean of transport  is required."),
          otherwise: yup.string(),
        }),
        thaiLastDate: yup
          .string()
          .required("The latest arrival date in Thailand is required."),
        stampEXP: yup.string().required("Permitted to stay in Thailand is required."),
      }),
    }),
    personal: yup.object().shape({
      titleID: yup.string().required("Title Type is required."),
      gender: yup.string().required("Gender Type is required."),
    }),

    // workpermit: yup.object({
    //   accommodationID: yup.string().when("visaissuance.thailand", {
    //     is: (thailand) => console.log(thailand),
    //     then: yup.string().required("Residence Type is required."),
    //     otherwise: yup.string(),
    //   }),
    //   houseNumber: yup.string().when("visaissuance.thailand", {
    //     is: (thailand) => thailand,
    //     then: yup.string().required("HouseNumber Type is required."),
    //     otherwise: yup.string(),
    //   }),
    //   soi: yup.string().when("visaissuance.thailand", {
    //     is: (thailand) => thailand,
    //     then: yup.string().required("Soi  is required."),
    //     otherwise: yup.string(),
    //   }),
    //   road: yup.string().when("visaissuance.thailand", {
    //     is: (thailand) => thailand,
    //     then: yup.string().required("Road  is required."),
    //     otherwise: yup.string(),
    //   }),
    //   addressInThailand: yup.string().when("visaissuance.thailand", {
    //     is: (thailand) => thailand,
    //     then: yup.string().required("Address  is required."),
    //     otherwise: yup.string(),
    //   }),
    //   ProvinceId: yup.string().when("visaissuance.thailand", {
    //     is: (thailand) => thailand,
    //     then: yup.string().required("Province  is required."),
    //     otherwise: yup.string(),
    //   }),
    //   DistrictId: yup.string().when("visaissuance.thailand", {
    //     is: (thailand) => thailand,
    //     then: yup.string().required("District  is required."),
    //     otherwise: yup.string(),
    //   }),
    //   SubDistrictId: yup.string().when("visaissuance.thailand", {
    //     is: (thailand) => thailand,
    //     then: yup.string().required("Sub-District  is required."),
    //     otherwise: yup.string(),
    //   }),
    //   Zipcode: yup.string().when("visaissuance.thailand", {
    //     is: (thailand) => thailand,
    //     then: yup.string().required("Zipcode  is required."),
    //     otherwise: yup.string(),
    //   }),
    // }),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      personal: {
        titleID: dataDetail?.personal?.titleID
          ? dataDetail?.personal?.titleID
          : null,
        gender: dataDetail?.personal?.gender
          ? dataDetail?.personal?.gender
          : null,

        personalID: dataDetail?.personal?.personalID
          ? dataDetail?.personal?.personalID
          : null,
        fistName: dataDetail?.personal?.firstname
          ? dataDetail?.personal?.firstname
          : "",
        middleName: dataDetail?.personal?.middleName
          ? dataDetail?.personal?.middleName
          : "",
        lastName: dataDetail?.personal?.lastName
          ? dataDetail?.personal?.lastName
          : "",
        nationalityID: dataDetail?.personal?.nationalityID
          ? dataDetail?.personal?.nationalityID
          : null,
        birthDate: dataDetail?.personal?.birthDate
          ? dataDetail?.personal?.birthDate
          : "",
        email: dataDetail?.personal?.email ? dataDetail?.personal?.email : "",
        mobile: dataDetail?.personal?.mobile
          ? dataDetail?.personal?.mobile
          : "",
        placeOfBirth: dataDetail?.personal?.placeOfBirth
          ? dataDetail?.personal?.placeOfBirth
          : "",

        passportNumber: dataDetail?.personal?.passportNumber
          ? dataDetail?.personal?.passportNumber
          : "",
        issuedAt: dataDetail?.personal?.issuedAt
          ? dataDetail?.personal?.issuedAt
          : "",
        soi: dataDetail?.personal?.soi ? dataDetail?.personal?.soi : "",
        road: dataDetail?.personal?.road ? dataDetail?.personal?.road : "",
        dateofIssue: dataDetail?.personal?.dateofIssue
          ? dataDetail?.personal?.dateofIssue
          : "",
        validuntil: dataDetail?.personal?.validuntil
          ? dataDetail?.personal?.validuntil
          : "",
        visatypeID: null,
        titleOther: dataDetail?.personal?.titleOther
          ? dataDetail?.personal?.titleOther
          : "",
        MaritalID: dataDetail?.personal?.maritalID
          ? dataDetail?.personal?.maritalID
          : null,
        MaritalOther: dataDetail?.personal?.MaritalOther
          ? dataDetail?.personal?.MaritalOther
          : "",
        addressInHomeCountry: dataDetail?.personal?.addressInHomeCountry
          ? dataDetail?.personal?.addressInHomeCountry
          : "",
        addressInThailand: dataDetail?.personal?.addressInThailand
          ? dataDetail?.personal?.addressInThailand
          : "",
        // ProvinceId: get(personal, "ProvinceId", ""),
        // SubDistrictId: get(personal, "SubDistrictId", ""),
        // DistrictId: get(personal, "DistrictId", ""),
        identificationNumber: dataDetail?.personal?.identificationNumber
          ? dataDetail?.personal?.identificationNumber
          : "",
        accommodationID: dataDetail?.personal?.accommodationID
          ? dataDetail?.personal?.accommodationID
          : null,
        houseNumber: dataDetail?.personal?.houseNumber
          ? dataDetail?.personal?.houseNumber
          : "",
      },
      visaissuance: {
        visaInssuanceId: dataDetail?.visaissuance?.visaInssuanceId
          ? dataDetail?.visaissuance?.visaInssuanceId
          : null,
        overseas:
          dataDetail?.visaissuance?.overseas !== null
            ? dataDetail?.visaissuance?.overseas
            : true,
        countryId: dataDetail?.visaissuance?.countryId
          ? dataDetail?.visaissuance?.countryId
          : "",
        cityId: dataDetail?.visaissuance?.cityId
          ? dataDetail?.visaissuance?.cityId
          : "",
        thailand: dataDetail?.visaissuance?.thailand
          ? dataDetail?.visaissuance?.thailand
          : false,
        theImmigrationBureauID: dataDetail?.visaissuance?.theImmigrationBureauID
          ? dataDetail?.visaissuance?.theImmigrationBureauID
          : null,
        visaTypeId: dataDetail?.visaissuance?.visaTypeId
          ? dataDetail?.visaissuance?.visaTypeId
          : null,
        visaExp: dataDetail?.visaissuance?.visaExp
          ? dataDetail?.visaissuance?.visaExp
          : "",
      },
      // visatypeId: dataDetail?.workpermit?.visatypeId
      //   ? dataDetail?.workpermit?.visatypeId
      //   : "",
      // visaNo: dataDetail?.workpermit?.visaNo
      //   ? dataDetail?.workpermit?.visaNo
      //   : "",
      // visaIssue: dataDetail?.workpermit?.visaIssue
      //   ? dataDetail?.workpermit?.visaIssue
      //   : "",
      // immPointID: dataDetail?.workpermit?.immPointID
      //   ? dataDetail?.workpermit?.immPointID
      //   : "",
      // immNo: dataDetail?.workpermit?.immNo ? dataDetail?.workpermit?.immNo : "",
      // fromCountryID: dataDetail?.workpermit?.fromCountryID
      //   ? dataDetail?.workpermit?.fromCountryID
      //   : "",
      // vehicleID: dataDetail?.workpermit?.vehicleID
      //   ? dataDetail?.workpermit?.vehicleID
      //   : "",
      // thaiLastDate: dataDetail?.workpermit?.thaiLastDate
      //   ? dataDetail?.workpermit?.thaiLastDate
      //   : "",
      // stampEXP: dataDetail?.workpermit?.stampEXP
      //   ? dataDetail?.workpermit?.stampEXP
      //   : "",
      workpermit: {
        accommodationID: dataDetail?.workpermit?.accommodationID
          ? dataDetail?.workpermit?.accommodationID
          : null,
        houseNumber: dataDetail?.workpermit?.houseNumber
          ? dataDetail?.workpermit?.houseNumber
          : "",
        soi: dataDetail?.workpermit?.soi ? dataDetail?.workpermit?.soi : "",
        road: dataDetail?.workpermit?.road ? dataDetail?.workpermit?.road : "",
        addressInThailand: dataDetail?.workpermit?.addressInThailand
          ? dataDetail?.workpermit?.addressInThailand
          : "",
        ProvinceId: dataDetail?.workpermit?.provinceId
          ? dataDetail?.workpermit?.provinceId
          : "",
        DistrictId: dataDetail?.workpermit?.districtId
          ? dataDetail?.workpermit?.districtId
          : "",
        SubDistrictId: dataDetail?.workpermit?.subDistrictId
          ? dataDetail?.workpermit?.subDistrictId
          : "",
        Zipcode: dataDetail?.workpermit?.zipcode
          ? dataDetail?.workpermit?.zipcode
          : "",
        workPermitNo: dataDetail?.workpermit?.workPermitNo
          ? dataDetail?.workpermit?.workPermitNo
          : "",
        // -----
        visatypeId: dataDetail?.workpermit?.visatypeId
          ? dataDetail?.workpermit?.visatypeId
          : "",
        visaNo: dataDetail?.workpermit?.visaNo
          ? dataDetail?.workpermit?.visaNo
          : "",
        visaIssue: dataDetail?.workpermit?.visaIssue
          ? dataDetail?.workpermit?.visaIssue
          : "",
        immPointID: dataDetail?.workpermit?.immPointID
          ? dataDetail?.workpermit?.immPointID
          : "",
        immNo: dataDetail?.workpermit?.immNo ? dataDetail?.workpermit?.immNo : "",
        fromCountryID: dataDetail?.workpermit?.fromCountryID
          ? dataDetail?.workpermit?.fromCountryID
          : "",
        vehicleID: dataDetail?.workpermit?.vehicleID
          ? dataDetail?.workpermit?.vehicleID
          : "",
        thaiLastDate: dataDetail?.workpermit?.thaiLastDate
          ? dataDetail?.workpermit?.thaiLastDate
          : "",
        stampEXP: dataDetail?.workpermit?.stampEXP
          ? dataDetail?.workpermit?.stampEXP
          : "",
      },
      document: {
        companyType: get(detail, "companyType.value", "C"),
        emp_idcard_no: get(detail, "emp_idcard_no.value", ""),
        emp_fullname: get(detail, "emp_fullname.value", ""),
        emp_address: get(detail, "emp_address.value", ""),
        emp_province_ddl: get(detail, "emp_province_ddl.value", ""),
        emp_district_ddl: get(detail, "emp_district_ddl.value", ""),
        emp_subdistrict_ddl: get(detail, "emp_subdistrict_ddl.value", ""),
        emp_tel: get(detail, "emp_tel.value", ""),

        WPCompanyRegisterNumber: get(
          detail,
          "WPCompanyRegisterNumber.value",
          ""
        ),
        WPCompanyName: get(detail, "WPCompanyName.value", ""),
        WPCompanyAddress: get(detail, "WPCompanyAddress.value", ""),
        WPCompanyOfficeNumber: get(detail, "WPCompanyOfficeNumber.value", ""),
        WPCompanyWebsite: get(detail, "WPCompanyWebsite.value", ""),
        WPCompanyProductsServices: get(
          detail,
          "WPCompanyProductsServices.value",
          ""
        ),
        WPContractTermType: get(detail, "WPContractTermType.value", ""),
        WPContactPersonInThai: get(detail, "WPContactPersonInThai.value", ""),
        WPContactRelationship: get(detail, "WPContactRelationship.value", ""),
        WPContactEmail: get(detail, "WPContactEmail.value", ""),
        WPContactMobile: get(detail, "WPContactMobile.value", ""),
        WPContractYear: get(detail, "WPContractYear.value", ""),
        WPContractMonth: get(detail, "WPContractMonth.value", ""),
        WPContractOther: get(detail, "WPContractOther.value", ""),
        WPContractPeriodFrom: get(detail, "WPContractPeriodFrom.value", ""),
        WPContractPeriodTo: get(detail, "WPContractPeriodTo.value", ""),
        JobPositionWorkPermit: getDefaultRow(
          detail,
          "JobPositionWorkPermit.value",
          defaultJobWorkpermitTable
        ).map(mapJobWorkpermitTable),
        // PhoneNumber: get(detail, "PhoneNumber.value", ""),
        // Email: get(detail, "Email.value", ""),
      },
      //   overseas: isOversea,
      //   thailand: !isOversea,
      //   theImmigrationBureauID:
      //     docDetail?.visaissurance?.theImmigrationBureauID || "",
      //   countryId: docDetail?.visaissurance?.countryId,
      //   cityId: docDetail?.visaissurance?.cityId,
    },
    onSubmit: async (values) => {

      const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
      const documentFields = Object.keys(formik.values.document);

      const getFieldListConfig = defaultType.filter((field) =>
        documentFields.includes(field.smartName)
      );

      const getValue = (field) => {
        switch (field.smartName) {
          case "JobPositionWorkPermit": {
            const jobTable = get(
              formik.values,
              `document.${field.smartName}`,
              []
            );
            const value = jobTable.filter((v) => !!v.jobTitle);

            return value || null;
          }
          default:
            return get(formik.values, `document.${field.smartName}`, null);
        }
      };

      const getSmartId = (field) =>
        get(detail, `${field.smartName}.smartId`, null);


      const params = {
        visaissuance: values.visaissuance,
        draftId: draftId,
        workpermit: {
          visatypeId: values.workpermit?.visatypeId ? values.workpermit?.visatypeId : null,
          visaNo: values.workpermit?.visaNo,
          visaIssue: values.workpermit?.visaIssue,
          immNo: values.workpermit?.immNo,
          immPointID: values.workpermit?.immPointID ? values.workpermit?.immPointID : null,
          fromCountryID: values.workpermit?.fromCountryID ? values.workpermit?.fromCountryID : null,
          vehicleID: values.workpermit?.vehicleID ? values.workpermit?.vehicleID : null,
          thaiLastDate: values.workpermit?.thaiLastDate,
          stampEXP: values.workpermit?.stampEXP,
          accommodationID: values.workpermit.accommodationID,
          houseNumber: values.workpermit.houseNumber,
          soi: values.workpermit.soi,
          road: values.workpermit.road,
          addressInThailand: values.workpermit.addressInThailand,
          provinceId: values.workpermit.ProvinceId,
          districtId: values.workpermit.DistrictId,
          subDistrictId: values.workpermit.SubDistrictId,
          zipcode: values.workpermit.Zipcode,
          workPermitNo: values?.workpermit?.workPermitNo,
          isRequest: dataDetail?.workpermit?.isRequest,
        },
        detail: getFieldListConfig.map((field) => ({
          smartName: field.smartName,
          smartId: getSmartId(field),
          partfromId: field.partfromId,
          configsmartId: field.configsmartId,
          linkTable: field.linkTable,
          value: getValue(field),
        })),
      };

      await dispatch(
        addPersonal({
          ...personalFieldResolver(values.personal),
          visatypeID: null,
        })
      );

      try {
        const response = await HttpClient.post(
          `/api/visaform/smartfrom/add`,
          params
        );
        const params2 = {
          draftId,
        };
        console.log(response);
        if (response.status) {
          await HttpClient.post(`/api/stampfrom/review`, params2);
          alert("Success");
          history.push(`/`);
          return response;
        }
        return Promise.reject(response);
      } catch (error) {
        const newError = error;
        throw newError;
      }
    },
  });
  const addressFieldOptions = useAddress({
    formik,
    ProvinceFieldName: "workpermit.ProvinceId",
    DistrictFieldName: "workpermit.DistrictId",
    SubDistrictFieldName: "workpermit.SubDistrictId",
    ZipcodeFieldName: "workpermit.Zipcode",
  });

  const vehicleConfigConfig = get(masterData, "vehicleConfig", []);
  const CountryConfig = get(masterData, "countryConfig", []);
  const VisaTypeConfig = get(masterData, "visaTypeConfig", []);
  const immPointConfig = get(masterData, "immPointConfig", []);
  const titleConfig = get(masterData, "titleConfig", []);
  const visaTypeConfig = get(masterData, "visaTypeConfig", []);
  const countryConfig = get(masterData, "countryEmbassy", []);
  const theImmigrationBureauConfig = get(
    masterData,
    "theImmigrationBureauConfig",
    []
  );
  const accommodationConfig = get(masterData, "accommodationConfig", []);
  //   console.log(draftId);

  const index = 0;

  const hideOverseas = dataDetail.smartserviceId === 'WPM'

  return (
    <div className={classes.root}>
      <div>
        <div style={{ display: "flex" }}>
          <TextField
            style={{ margin: 5 }}
            inputProps={{ readOnly: true }}
            variant="outlined"
            value={dataDetail?.smartNo}
            placeholder="No."
          />
          <TextField
            style={{ margin: 5 }}
            inputProps={{ readOnly: true }}
            variant="outlined"
            value={dataDetail?.smartserviceName}
            placeholder="Refer Name."
          />
        </div>


        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={7}>
                  <Typography variant="h6" className={classes.title}>
                    Personal Information
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <PersonalInfoSection formik={formik} disabled={disabled.PersonalInformation} />
            </TableBody>
          </Table>
        </TableContainer>

        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <VisaIssuanceSection colSpan={7} formik={formik} disabled={disabled.VisaIssuance} />
          </Table>
        </TableContainer>

        {formik.values.visaissuance.thailand && (<TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={7}>
                  <Typography
                    variant="h6"
                    className={classes.title}
                  >
                    Address in Thailand
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <WorkPermit formik={formik} disabled={disabled.AddressInThailand} />
            </TableBody>
          </Table>
        </TableContainer>)}

        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={7}>
                  <Typography
                    variant="h6"
                    className={classes.title}
                  >
                    Passport
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <PassportSection formik={formik} disabled={disabled.Passport} />
            </TableBody>
          </Table>
        </TableContainer>

        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={7}>
                  <Typography
                    variant="h6"
                    className={classes.title}
                  >
                    Latest travel information into Thailand
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TravelInfo formik={formik} disabled={disabled.LatestTravelnformation} />
            </TableBody>
          </Table>
        </TableContainer>

        {dataDetail?.workpermit?.isRequest && <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={4}>
                  <Typography
                    variant="h6"
                    className={classes.title}
                  >
                    No. of an alien (on work permit/ digital work permit)
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <StyledTableCell colSpan={4}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>
                        No. of an alien (14 Digits)
                      </InputLabel>
                      <TextField
                        disabled={disabled.DigitalWorkPermit || !canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name={`workpermit.workPermitNo`}
                        value={get(
                          formik.values,
                          `workpermit.workPermitNo`,
                          ""
                        )}
                        error={isError(
                          `workpermit.workPermitNo`,
                          formik
                        )}
                        helperText={getErrorMessage(
                          `workpermit.workPermitNo`,
                          formik
                        )}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>}

        {dataDetail?.workpermit?.isRequest && <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={4}>
                  <Typography
                    variant="h6"
                    className={classes.title}
                  >
                    Company Information
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <CompanyInfoSection formik={formik} disabled={disabled.CompanyInformation} />
            </TableBody>
          </Table>
        </TableContainer>}

        {dataDetail?.workpermit?.isRequest && <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={4}>
                  <Typography
                    variant="h6"
                    className={classes.tableTitle}
                  >
                    Job Information
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <JobSection formik={formik} disabled={disabled.JobInformation} />
            </TableBody>
          </Table>
        </TableContainer>}

        <UploadDucument
          // setSaveDraft={setSaveDraft}
          handleSubmitForm={() => {
            formik.handleSubmit();
          }}
          isSubmitPreapprove
          statusId={dataDetail?.statausID}
        // handleClickBack={() =>
        //   dispatch(setSmartFormStep(LTR_STEP.SHOW_FORM_WORKPERMITSTEP))
        // }
        // conditionPrivate={detail?.IncomeMorethanHSPC?.value}
        />
      </div>
    </div>
  );
}

export default withLayout(PreApproved);
